import { render, staticRenderFns } from "./IconCogSolid.vue?vue&type=template&id=94e3cb48"
import script from "./IconCogSolid.vue?vue&type=script&lang=js"
export * from "./IconCogSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports